const FormUser = () => {
  return <div>FormUser</div>;
};

export default FormUser;
